import { useState, useEffect } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import ApplicationTab from "../TeamManagement/Tabs/ApplicationTab";
import {
  APPLICATION_LIMIT,
  APPLICATION_TAB_TYPE,
  AR_CONTENT_TAB,
  constantKeyMap,
  MODULE_LIMIT,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
} from "../../constant/constants";
import apiClient from "../../apiClient";
import { DELETE_ALLOCATION } from "../../apiClient/apiEndpoints";
import SelectionLine from "../SelectionLine";
import { getAllocatedApplication, getAllocatedModuleList } from "../../apiClient/apiDataFetcher";
import { makeFilterParams, modalName, visibleAssignSectionList } from "../../utils/general";
import { useModalContext } from "../../modal/context/ModalProvider";
import { saveTotalCount } from "../../store/slice/filterOptions";
import { useDispatch } from "react-redux";

const { useUnoSelector } = UnoStoreHooks;

const ApplicationContent = ({ UUID, search, isMobileView, defaultTab, setDefaultTab, selectedFilter }) => {
  const { closeModal, openModal } = useModalContext();
  const dispatch = useDispatch();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  let UNO_URL = configData.config.UNO_URL;

  const [selectedItems, setSelectedItems] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
    [AR_CONTENT_TAB]: [],
  });

  const [applicationList, setApplicationList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "application"
  });

  const [moduleList, setModuleList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [environmentList, setEnvironmentList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [skillStreamList, setSkillStreamList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [skillSchoolList, setSkillSchoolList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const [arContentList, setArContentList] = useState({
    hasMore: true,
    page: 1,
    list: [],
    loader: false,
    type: "module"
  });

  const handleSelectAllItems = (action) => {
    const mapping = {
      [RESOURCE_APPLICATION_TAB]: applicationList.list,
      [RESOURCE_MODULE_TAB]: moduleList?.list,
      [RESOURCE_ENVIRONMENT_TAB]: environmentList?.list,
      [RESOURCE_SKILL_STREAM_TAB]: skillStreamList?.list,
      [RESOURCE_SKILL_SCHOOL_TAB]: skillSchoolList?.list,
      [AR_CONTENT_TAB]: arContentList?.list,
    };
    let _list = mapping[defaultTab].filter((e) => e.inherit === false).map((e) => ({ id: e.uuid, data: e }));
    let filterItem = {
      all: _list,
      none: [],
    };
    setSelectedItems((prev) => ({ ...prev, [defaultTab]: filterItem[action] }));
  };

  const handleClearSelection = () => {
    setSelectedItems((pre) => ({ ...pre, [defaultTab]: [] }));
  };

  const getPaginatedApplications = async (pageNumber, querySearch, selectedItem = []) => {
    let page = pageNumber || 1;
    setApplicationList((pre) => ({ ...pre, loader: page == 1, page: page }));
    try {
      let queryParams = {
        page: page,
        search: querySearch,
        tagIds: selectedItem.length > 0 ? selectedItem.map((e) => e.key) : null,
        inherit: true
      };
      let data = await getAllocatedApplication({ UNO_URL, UUID: UUID, queryParams });
      let list = data.list.filter(e => e.uuid != configData.config.applicationId);
      let total = data.total;

      dispatch(saveTotalCount({ data: { [RESOURCE_APPLICATION_TAB]: total } }));

      setApplicationList((pre) => ({
        ...pre,
        hasMore: list.length === APPLICATION_LIMIT,
        page: list.length === APPLICATION_LIMIT ? page + 1 : page,
        list: page === 1 ? [...list] : [...pre.list, ...list],
      }));

    } catch (error) {
      console.log(error);
    } finally {
      setApplicationList((pre) => ({ ...pre, loader: false }));
    }
  };

  const getPaginatedAssignedModules = async (pageNumber, querySearch, selectedItem = [], resourceType) => {
    let page = pageNumber || 1;
    let fetchStates = {
      [RESOURCE_MODULE_TAB]: setModuleList,
      [RESOURCE_ENVIRONMENT_TAB]: setEnvironmentList,
      [RESOURCE_SKILL_STREAM_TAB]: setSkillStreamList,
      [RESOURCE_SKILL_SCHOOL_TAB]: setSkillSchoolList,
      [AR_CONTENT_TAB]: setArContentList,
    };

    fetchStates[resourceType]((pre) => ({ ...pre, loader: page == 1, page: page }));

    try {
      let filterParams = {};
      if (selectedItem.length > 0) {
        filterParams = makeFilterParams(selectedItem);
      }
      let queryParams = {
        inherit: true,
        page: page,
        search: querySearch,
        ...filterParams,
      };

      let data = await getAllocatedModuleList({ UNO_URL: configData.config.UNO_URL, UUID: UUID, queryParams, resourceType });

      let list = data.list;
      let total = data.total;

      fetchStates[resourceType]((pre) => ({
        ...pre,
        hasMore: list.length === MODULE_LIMIT,
        page: list.length === MODULE_LIMIT ? page + 1 : page,
        list: page === 1 ? [...list] : [...pre.list, ...list],
      }));

      dispatch(saveTotalCount({ data: { [resourceType]: total } }));

    } catch (error) {
      console.log(error);
    } finally {
      fetchStates[resourceType]((pre) => ({ ...pre, loader: false }));
    }
  };

  const handleCallAssignedData = () => {

    let _visibleSectionList = visibleAssignSectionList().map(e => e.id_link);
    if (!(_visibleSectionList.length)) return;
    let allowSectionList = _visibleSectionList.map(e => constantKeyMap[e]);
    if (allowSectionList.includes(RESOURCE_APPLICATION_TAB)) getPaginatedApplications(1, search, selectedFilter[RESOURCE_APPLICATION_TAB]);
    if (allowSectionList.includes(RESOURCE_MODULE_TAB)) getPaginatedAssignedModules(1, search, selectedFilter[RESOURCE_MODULE_TAB], RESOURCE_MODULE_TAB);
    if (allowSectionList.includes(RESOURCE_ENVIRONMENT_TAB)) getPaginatedAssignedModules(1, search, selectedFilter[RESOURCE_ENVIRONMENT_TAB], RESOURCE_ENVIRONMENT_TAB);
    if (allowSectionList.includes(RESOURCE_SKILL_STREAM_TAB)) getPaginatedAssignedModules(1, search, selectedFilter[RESOURCE_SKILL_STREAM_TAB], RESOURCE_SKILL_STREAM_TAB);
    if (allowSectionList.includes(RESOURCE_SKILL_SCHOOL_TAB)) getPaginatedAssignedModules(1, search, selectedFilter[RESOURCE_SKILL_SCHOOL_TAB], RESOURCE_SKILL_SCHOOL_TAB);
    if (allowSectionList.includes(AR_CONTENT_TAB)) getPaginatedAssignedModules(1, search, selectedFilter[AR_CONTENT_TAB], AR_CONTENT_TAB);
  };

  useEffect(() => {
    handleCallAssignedData();
  }, [UUID, search, selectedFilter]);

  const handelUnassignApplication = async () => {
    try {
      const payload = {
        applications: (selectedItems[RESOURCE_APPLICATION_TAB] ?? []).map((e) => e.id),
        resources: [
          ...(selectedItems[RESOURCE_MODULE_TAB] ?? []),
          ...(selectedItems[RESOURCE_ENVIRONMENT_TAB] ?? []),
          ...(selectedItems[RESOURCE_SKILL_STREAM_TAB] ?? []),
          ...(selectedItems[RESOURCE_SKILL_SCHOOL_TAB] ?? []),
          ...(selectedItems[AR_CONTENT_TAB] ?? []),
        ].map((e) => e.id),
      };
      await apiClient.post(`${configData.config.UNO_URL}${DELETE_ALLOCATION}/group/${UUID}`, payload);
      handleCallAssignedData();
      setSelectedItems({
        [RESOURCE_APPLICATION_TAB]: [],
        [RESOURCE_MODULE_TAB]: [],
        [RESOURCE_ENVIRONMENT_TAB]: [],
        [RESOURCE_SKILL_STREAM_TAB]: [],
        [RESOURCE_SKILL_SCHOOL_TAB]: [],
        [AR_CONTENT_TAB]: [],
      });
      setTimeout(() => {
        openModal({
          modalName: modalName.SUCCESSFULLY_POPUP,
          transferring: false,
          message: "Unassign successfully.",
        });
      }, 1000);
      setTimeout(() => {
        closeModal();
      }, 3000);
    } catch (error) {
      closeModal();
      console.log(error);
    }
  };

  const handlePaginationLoadMoreData = async () => {
    const mapping = {
      [RESOURCE_APPLICATION_TAB]: {
        storedValue: applicationList,
        callerFunction: getPaginatedApplications,
      },
      [RESOURCE_MODULE_TAB]: {
        storedValue: moduleList,
        callerFunction: getPaginatedAssignedModules,
      },
      [RESOURCE_ENVIRONMENT_TAB]: {
        storedValue: environmentList,
        callerFunction: getPaginatedAssignedModules,
      },
      [RESOURCE_SKILL_STREAM_TAB]: {
        storedValue: skillStreamList,
        callerFunction: getPaginatedAssignedModules,
      },
      [RESOURCE_SKILL_SCHOOL_TAB]: {
        storedValue: skillSchoolList,
        callerFunction: getPaginatedAssignedModules,
      },
      [AR_CONTENT_TAB]: {
        storedValue: arContentList,
        callerFunction: getPaginatedAssignedModules,
      },
    };
    mapping[defaultTab].callerFunction(mapping[defaultTab].storedValue.page, search[defaultTab], [], defaultTab);
  };

  const nameMapping = {
    [RESOURCE_APPLICATION_TAB]: {
      label: "Applications",
      data: applicationList.list.filter((e) => e.inherit === false),
    },
    [RESOURCE_MODULE_TAB]: { label: "Modules", data: moduleList?.list.filter((e) => e.inherit === false) },
    [RESOURCE_ENVIRONMENT_TAB]: {
      label: "Environments",
      data: environmentList?.list.filter((e) => e.inherit === false),
    },
    [RESOURCE_SKILL_STREAM_TAB]: {
      label: "Skill Stream Modules",
      data: skillStreamList?.list.filter((e) => e.inherit === false),
    },
    [RESOURCE_SKILL_SCHOOL_TAB]: {
      label: "Skill School Modules",
      data: skillSchoolList?.list.filter((e) => e.inherit === false),
    },
    [AR_CONTENT_TAB]: {
      label: "AR Content Modules",
      data: arContentList?.list.filter((e) => e.inherit === false),
    },
  };

  let renderListData = {
    [RESOURCE_APPLICATION_TAB]: applicationList,
    [RESOURCE_MODULE_TAB]: moduleList,
    [RESOURCE_ENVIRONMENT_TAB]: environmentList,
    [RESOURCE_SKILL_STREAM_TAB]: skillStreamList,
    [RESOURCE_SKILL_SCHOOL_TAB]: skillSchoolList,
    [AR_CONTENT_TAB]: arContentList,
  };


  return (
    <>
      {!isMobileView && UUID !== userData.user.group.uuid && (
        <SelectionLine
          buttonShow={true}
          showAssignIcon={false}
          showUnassignIcon={true}
          showMoveIcon={false}
          showStatusChangeIcon={false}
          type={APPLICATION_TAB_TYPE}
          selectedItems={selectedItems[defaultTab] || []}
          allSelectedItems={Object.values(selectedItems).flat(Infinity)}
          tabName={APPLICATION_TAB_TYPE}
          showDropdown={false}
          totalItemsCount={nameMapping[defaultTab]?.data?.length || 0}
          handleClickMultipleSelect={handleSelectAllItems}
          handelUnassignApplication={handelUnassignApplication}
          text={
            userData.user.group.uuid !== UUID ? (
              <>
                {Object.values(selectedItems).flat(Infinity).length} are selected.
                <span className="cursor-pointer text-primary" onClick={() => handleClearSelection()}>
                  Clear Selection
                </span>
              </>
            ) : null
          }
        />
      )}

      <ApplicationTab
        renderList={renderListData[defaultTab].list}
        hasMore={renderListData[defaultTab].hasMore}
        loading={renderListData[defaultTab].loader}
        handlePaginationLoadMoreData={handlePaginationLoadMoreData}
        defaultTab={defaultTab}
        setDefaultTab={setDefaultTab}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        isMobileView={isMobileView}
      />
    </>
  );
};

export default ApplicationContent;
